import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import { protocoloCero } from '../../json/protocoloCero';

const ProtocoloCero = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Protocolo Cero
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    protocoloCero.map((item, index) => (
                        <div key={ index } className='col-md-4 col-sm-6 col-12'>
                            <div className={ styles.container }>
                                <a className={ styles.link } href={ item.urlDocumento } target='_blank' rel='noopener noreferrer'>
                                    <div className={ styles.item }>
                                        <p className={ styles.textLink }>{item.documento}
                                            { item.nombreDocumento }
                                        </p>
                                        <i className={`${ styles.iconLink } ${ item.icono }`} aria-hidden='true'></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ProtocoloCero